import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { CDN_URL } from '@maximizer/core/shared/domain';

@Component({
  selector: 'maximizer-card-button',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div
      class="w-[270px] h-[140px] 3xl:h-[210px] shadow-circle flex flex-col justify-center items-center m-1 rounded border border-white hover:cursor-pointer hover:border hover:border-neutral-40 hover:shadow-none"
    >
      <div class="px-2 flex flex-col justify-start text-center">
        <div>
          <img
            class="w-[60px] h-[60px] 3xl:w-[100px] 3xl:h-[100px]"
            [src]="cdn + '/assets/images/' + image"
            alt="{{ title }}"
          />
        </div>
        @if (title) {
          <h6 class="text-neutral-80">{{ title }}</h6>
        }
        @if (description) {
          <p class="text-caption px-4">{{ description }}</p>
        }
        @if (link) {
          <a
            class="text-caption text-info no-underline py-1 hover:cursor-pointer hover:underline"
            href="{{ linkUrl }}"
            title="{{ linkTitle }}"
            target="_blank"
            rel="noopener"
            >{{ link }}</a
          >
        }
      </div>
    </div>
  `,
})
export class CardButtonComponent {
  @Input() image: string | undefined;
  @Input() title: string | undefined;
  @Input() description: string | undefined;
  @Input() link: string | undefined;
  @Input() linkUrl: string | undefined;
  @Input() linkTitle: string | undefined;

  constructor(@Inject(CDN_URL) public cdn: string) {}
}
